import * as React from "react";

import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import {
  FORM_CONTROL_APPEARANCE_CLASS_NAME,
  FORM_INPUT_CLASS_NAME,
} from "@/components/Forms/form-control-styles";

const inputVariants = cva(
  "flex w-full border file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        default: FORM_INPUT_CLASS_NAME,
        none: `${FORM_CONTROL_APPEARANCE_CLASS_NAME} placeholder:text-slate-500 disabled:opacity-100`,
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
